import { useQuery } from '@tanstack/react-query';
import { getDocumentCounts, getCounters } from '../services/dashboard-api';

/**
 * Hook to get document counts for all statuses
 */
export function useDocumentCounts() {
  return useQuery({
    queryKey: ['documentCounts'],
    queryFn: () => getDocumentCounts(),
    refetchInterval: 15000, // Refresh every 15 seconds
  });
}

/**
 * Hook to get pending document counts from counters table
 */
export function usePendingCounts() {
  return useQuery({
    queryKey: ['pendingCounts'],
    queryFn: () => getCounters(),
    refetchInterval: 10000, // Refresh every 10 seconds
  });
}
